<template>
  <nav class="mobile-bottom-menu">
    <button
      class="mobile-bottom-menu__button"
      :class="{ [$class('active')]: activeIcon === 'menuDrawer' }"
      @click="toggleOverlay({
        component: 'menu-drawer',
        ignoreDismissed: true,
        namespace: 'menuDrawer',
      })"
      @mousedown="loadComponent('menu-drawer')"
      @touchstart="loadComponent('menu-drawer')"
    >
      <icon-grid />

      <span
        class="text-body-2xs"
        v-text="$string('general.mobile_bottom_menu.menu')"
      />
    </button>

    <a
      v-if="liquid.settings.wishlist_link"
      :class="{ [$class('active')]: activeIcon === 'wishlist' }"
      class="mobile-bottom-menu__button"
      :href="liquid.settings.wishlist_link"
    >
      <span
        v-html="`<!-- include 'wishlist-link-mobile' -->`"
      />

      <div class="mobile-bottom-menu__wrapper wishlist-static">
        <icon-wishlist />

        <span
          class="mobile-bottom-menu__badge text-body-xs"
          aria-hidden="true"
        />
      </div>

      <span
        class="text-body-2xs"
        v-text="$string('general.mobile_bottom_menu.wishlist')"
      />
    </a>

    <a
      class="mobile-bottom-menu__button"
      :class="{ [$class('active')]: activeIcon === 'cartDrawer' }"
      :href="$variable('routes.cart.url')"
      @click="handleCartToggle"
      @mousedown="loadComponent('cart-drawer')"
    >
      <div class="mobile-bottom-menu__wrapper">
        <icon-bag />

        <span
          v-if="cart.item_count > 0"
          class="mobile-bottom-menu__badge text-body-xs"
          :class="{ 'badge--large': cart.item_count > 9 }"
          aria-hidden="true"
          v-text="cart.item_count"
        />
      </div>

      <span
        class="text-body-2xs"
        v-text="$string('general.mobile_bottom_menu.bag')"
      />
    </a>

    <a
      v-if="liquid.settings.stores_link"
      :class="{ [$class('active')]: activeIcon === 'stores' }"
      class="mobile-bottom-menu__button"
      :href="liquid.settings.stores_link"
    >
      <icon-store />

      <span
        class="text-body-2xs"
        v-text="$string('general.mobile_bottom_menu.stores')"
      />
    </a>

    <a
      class="mobile-bottom-menu__button"
      :class="{ [$class('active')]: activeIcon === 'account' }"
      :href="$variable('routes.account.url')"
    >
      <icon-account />

      <span
        class="text-body-2xs"
        v-text="$string('general.mobile_bottom_menu.account')"
      />
    </a>
  </nav>
</template>

<script>

/**
 * Vue: Mobile bottom menu (mobile-bottom-menu)
 * -----------------------------------------------------------------------------
 * Mobile Bottom Menu.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
import { mapActions, mapGetters, mapState } from 'vuex'

import IconGrid from '~icons/misc/grid.svg'
import IconWishlist from '~icons/misc/wishlist.svg'
import IconBag from '~icons/misc/bag.svg'
import IconStore from '~icons/misc/store.svg'
import IconAccount from '~icons/misc/account.svg'

export default {
  name: 'MobileBottomMenu',

  components: {
    IconGrid,
    IconWishlist,
    IconBag,
    IconStore,
    IconAccount,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
      }),
    },
  },

  data() {
    return {
    }
  },

  computed: {

    /**
     * Map Vuex getters.
     */
    ...mapGetters({
      getActiveOverlay: 'overlays/getActiveOverlay',
    }),

    /**
     * Map Vuex state.
     */
    ...mapState({
      cart: (state) => state.cart.response,
    }),

    activeIcon() {
      if (this.getActiveOverlay === 'cartDrawer') {
        return 'cartDrawer'
      }

      if (this.getActiveOverlay === 'menuDrawer') {
        return 'menuDrawer'
      }

      const currentUrl = window.location.href

      if (currentUrl.includes('/account')) {
        return 'account'
      }

      if (currentUrl === this.liquid.settings.wishlist_link) {
        return 'wishlist'
      }

      if (currentUrl === this.liquid.settings.stores_link) {
        return 'stores'
      }

      return null
    },

  },

  mounted() {
    // Not empty
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      loadComponent: 'components/load',
      toggleOverlay: 'overlays/toggle',
    }),


    /**
     * Handle cart toggle.
     * - Open cart drawer on mobile.
     * @param {Object} event - Click event.
     */
    handleCartToggle(event) {
      if (cnvs.page.type === 'cart') {
        return
      }

      event.preventDefault()

      this.toggleOverlay({
        component: 'cart-drawer',
        ignoreDismissed: true,
        namespace: 'cartDrawer',
      })
    },
  },
}
</script>
